module.exports = __webpack_public_path__ + "img/1.aa3dd245.jpg";